import React from "react";

function Datasheets() {
  return <p>Datasheets</p>;
}

export default Datasheets;
